export default {
    LOZAD_LOAD: 'LozadLoad',
    IMG_LOAD: 'ImgLoad',
    IMG_ERROR: 'LazyImgError',
};
